// ShippingPolicy.js
import React from "react";
import "./ShippingPolicy.css";

const ShippingPolicy = () => {
  return (
    <div className="shipping-policy-container">
      <h2 className="title">Shipping &amp; Delivery Policy</h2>

      <section className="section">
        <p>
          At <strong>Kraafty.com</strong>, it is our endeavour to make your shopping experience
          seamless, enjoyable, simple and hassle-free. Therefore, we ensure that every product you
          order is in perfect condition and that it reaches you within the time stipulated by us.
          Please peruse our Shipping &amp; Delivery Policy outlined below.
        </p>
      </section>

      <section className="section">
        <h3 className="section-title">Types of Shipping Available – India</h3>
        <ul>
          <li>
            <strong>Normal Shipping:</strong> Surface transport – 7-10 business days
          </li>
          <li>
            <strong>Express Shipping:</strong> Air transport – 4-5 business days
          </li>
        </ul>
      </section>

      <section className="section">
        <h3 className="section-title">Shipping Charges – Domestic Orders</h3>
        <p>
          All shipping charges are mentioned on the product page. Fumigation &amp; handling are based on
          actuals. Charges may vary depending upon volume, weight and fragility of the products.
        </p>
      </section>

      <section className="section">
        <h3 className="section-title">Types of Shipping Available – International</h3>
        <ul>
          <li>
            <strong>Stranded Shipping:</strong> Air transport – 10-30 business days
          </li>
          <li>
            <strong>Express Shipping:</strong> Air transport – 4-8 business days
          </li>
        </ul>
      </section>

      <section className="section">
        <h3 className="section-title">Shipping Charges – International Orders</h3>
        <p>
          All shipping charges are mentioned on the product page. Fumigation &amp; handling are based on
          actuals. <strong>Duties and taxes will be extra</strong> for all orders as per each country’s custom
          policy. Buyers are responsible for paying their country’s duties &amp; taxes. (Charges may vary
          depending upon volume, weight and fragility.)
        </p>
      </section>

      <section className="section">
        <h3 className="section-title">Extra Handling Charges</h3>
        <p>
          Additional handling charges are applicable on Furniture, Lighting, Wall Clocks &amp; Mirrors.
        </p>
        <p className="note">
          <em>
            Note: Estimated delivery time might vary during sale periods or other contingencies. For
            international buyers, customs inspections may cause additional delays.
          </em>
        </p>
      </section>

      <section className="section">
        <h3 className="section-title">Packaging</h3>
        <p>
          All items are carefully packaged at our fulfilment centre to avoid damage. Fragile items are
          packed with high-quality bubble sheets and air cushions. Products are wrapped and sealed
          with tamper-proof packaging to ensure you receive your order in perfect condition. If you
          notice any discrepancies, or if the package looks tampered with or damaged, please do not
          accept the package and immediately contact our Customer Service at {" "}
          <a href="tel:+918005629558">+91&nbsp;8005629558</a> (Mon-Sat&nbsp;10&nbsp;AM–7&nbsp;PM&nbsp;IST) or email {" "}
          <a href="mailto:support@kraafty.com">support@kraafty.com</a>.
        </p>
      </section>

      <section className="section">
        <h3 className="section-title">Delivery Time &amp; Tracking Information</h3>
        <p>
          Please allow up to 7-10 business days for normal domestic deliveries and 10-30 business days
          for normal international deliveries from the day you receive the order confirmation.
          Delivery partners will attempt delivery once before the package is returned. Re-shipping
          charges for missed packages will be borne by the customer.
        </p>
        <p>
          Provide a complete and accurate address including zip code and mobile number to facilitate
          faster delivery.
        </p>
        <p>
          You will receive an email when the order is shipped and once it is delivered. For further
          assistance, contact Customer Service at {" "}
          <a href="tel:+918005629558">+91&nbsp;8005629558</a> (Mon-Sat&nbsp;10&nbsp;AM–7&nbsp;PM&nbsp;IST) or email {" "}
          <a href="mailto:support@kraafty.com">support@kraafty.com</a>.
        </p>
      </section>

      <section className="section">
        <h3 className="section-title">Payment Policy</h3>
        <p>
          Kraafty.com offers multiple payment options: all major Credit/Debit Cards, UPI and Net
          Banking. All Debit/Credit card information remains confidential. Our trusted payment gateway
          is compliant with the highest standards in the payment processing industry, ensuring your
          personal information is safe.
        </p>
      </section>
    </div>
  );
};

export default ShippingPolicy;
